export default __webpack_public_path__ + "static/media/settings_room_device_speed.2ac2c7e9.svg";